import { Link } from 'react-router-dom';
import { packs } from '../../../mocks/products';
import Button from '../../../components/base/Button';

export default function FeaturedPacks() {
  const featuredPacks = packs.filter(pack => pack.featured).slice(0, 4);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-gradient-to-r from-red-600 to-orange-600 text-white px-6 py-3 rounded-full text-base font-bold mb-6 shadow-lg">
            <i className="ri-fire-fill mr-2 text-xl"></i>
            OFERTAS FLASH DEL MES
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            Packs con Descuentos Brutales
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-medium">
            Stock limitado hasta fin de mes. Cada día 1 renovamos las ofertas. ¡Aprovecha antes de que se agoten!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {featuredPacks.map((pack) => (
            <div 
              key={pack.id}
              className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-orange-200 hover:border-orange-400 relative transform hover:scale-[1.02]"
            >
              {pack.limitedStock && pack.limitedStock < 30 && (
                <div className="absolute top-6 left-6 bg-gradient-to-r from-red-600 to-red-700 text-white px-5 py-3 rounded-full text-base font-bold z-10 animate-pulse shadow-xl">
                  <i className="ri-alarm-warning-fill mr-2"></i>
                  ¡Solo {pack.limitedStock} packs!
                </div>
              )}

              <div className="relative h-72 overflow-hidden">
                <img 
                  src={pack.image} 
                  alt={pack.name}
                  className="w-full h-full object-cover object-top"
                />
                {pack.freeShipping && (
                  <div className="absolute top-6 right-6 bg-gradient-to-r from-green-500 to-green-600 text-white px-5 py-3 rounded-full text-base font-bold flex items-center space-x-2 shadow-xl">
                    <i className="ri-truck-line text-lg"></i>
                    <span>Envío Gratis</span>
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                  <div className="flex items-center justify-between text-white">
                    <span className="text-base font-bold flex items-center">
                      <i className="ri-calendar-line mr-2 text-lg"></i>
                      Válido hasta fin de mes
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {pack.name}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed text-base">
                  {pack.description}
                </p>

                <div className="bg-orange-50 rounded-2xl p-6 mb-6 border-2 border-orange-200">
                  <h4 className="font-bold text-gray-900 mb-4 text-base flex items-center">
                    <i className="ri-gift-line text-orange-600 mr-2 text-xl"></i>
                    Incluye:
                  </h4>
                  <ul className="space-y-3">
                    {pack.items.map((item, idx) => (
                      <li key={idx} className="flex items-center text-base text-gray-700">
                        <i className="ri-checkbox-circle-fill text-orange-500 mr-3 text-lg"></i>
                        <span><strong>{item.quantity}x</strong> {item.name}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-gradient-to-br from-orange-600 to-red-600 rounded-2xl p-8 mb-6 text-white shadow-xl">
                  <div className="flex items-end justify-between">
                    <div>
                      <p className="text-base text-orange-100 line-through mb-2 font-medium">
                        Antes: {pack.regularPrice.toFixed(2)}€
                      </p>
                      <p className="text-5xl font-black mb-3">
                        {pack.packPrice.toFixed(2)}€
                      </p>
                      <p className="text-base font-bold bg-white/25 inline-block px-4 py-2 rounded-full">
                        <i className="ri-arrow-down-line mr-1"></i>
                        Ahorras {pack.savings.toFixed(2)}€
                      </p>
                    </div>
                    <div className="text-right">
                      <div className="bg-white/20 rounded-xl px-5 py-3 backdrop-blur-sm">
                        <p className="text-sm text-orange-100 font-medium">Total</p>
                        <p className="text-3xl font-black">
                          {pack.totalItems}
                        </p>
                        <p className="text-xs text-orange-100 font-medium">unidades</p>
                      </div>
                    </div>
                  </div>
                </div>

                <Link to={`/paquetes/${pack.id}`}>
                  <Button fullWidth size="lg" className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-lg font-bold py-4 shadow-lg transform hover:scale-105 transition-all">
                    <i className="ri-shopping-cart-line mr-2"></i>
                    Comprar Ahora
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/paquetes">
            <Button size="lg" className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-lg font-bold px-8 py-4 shadow-xl transform hover:scale-105 transition-all">
              Ver Todas las Ofertas Flash
              <i className="ri-flashlight-line ml-3 text-xl"></i>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}